import { Description, Label, Radio, RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getDifficultyOptions } from '../../../helpers/diagnostic'
import Badge from '../../tailwind/Badge'

const I18N_PREFIX = 'create_career.hardness_of_selection.'

// Ausgeglichen ist der Default (DEFAULT_SELECTION_DIFFICULTY) und war in der
// alten Beschreibung die einzige fett hervorgehobene Option.
const RECOMMENDED = 'NORMAL'

/**
 * Controlled. Karten statt Dropdown: die drei Optionen unterscheiden sich
 * nicht im Namen, sondern in ihrer Konsequenz. Vorher standen alle drei
 * Erklaerungen in einem Absatz ueber einem Select, man musste also lesen,
 * zuordnen und danach erst waehlen.
 */
const HardnessOfSelection = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <>
      <h2 className='text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight'>
        {t(I18N_PREFIX + 'title')}
      </h2>
      <p className='mt-2 max-w-2xl text-sm/6 text-gray-900'>
        {t(I18N_PREFIX + 'description')}
      </p>

      <RadioGroup
        value={value}
        onChange={onChange}
        className='mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3'
        aria-label={t(I18N_PREFIX + 'title')}
      >
        {getDifficultyOptions().map(({ difficulty, label }) => (
          <Radio
            key={difficulty}
            value={difficulty}
            className={({ checked }) =>
              clsx(
                'group relative flex cursor-pointer flex-col rounded-xl border bg-slate-50 p-4 text-left',
                'focus:outline-none data-[focus]:ring-2 data-[focus]:ring-blue-600 data-[focus]:ring-offset-2',
                checked
                  ? 'border-primaryBlue ring-1 ring-primaryBlue'
                  : 'border-slate-200 hover:border-primaryBlue hover:ring-1 hover:ring-primaryBlue'
              )
            }
          >
            {({ checked }) => (
              <>
                {checked && (
                  <CheckCircleIcon
                    aria-hidden='true'
                    className='absolute right-3 top-3 size-5 text-primaryBlue'
                  />
                )}
                {/* flex-wrap mit shrink-0 am Badge: in der schmalen Karte
                    soll es als Ganzes in die naechste Zeile rutschen statt
                    mitten im Text umzubrechen. */}
                <Label className='flex flex-wrap items-center gap-x-2 gap-y-1 pr-6 font-semibold text-gray-900'>
                  {t(label)}
                  {difficulty === RECOMMENDED && (
                    <span className='shrink-0 whitespace-nowrap'>
                      <Badge
                        color='green'
                        text={t(
                          'create_career.challenge_card.recommended_by_aivy_label'
                        )}
                      />
                    </span>
                  )}
                </Label>
                <Description className='mt-1 text-sm text-gray-900'>
                  {t(I18N_PREFIX + `options.description_${difficulty}`)}
                </Description>
              </>
            )}
          </Radio>
        ))}
      </RadioGroup>
    </>
  )
}

HardnessOfSelection.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default HardnessOfSelection
